import { useEffect, useRef, useState } from 'react'
import Button from '../../../../components/_legacy/Button'
import Input from '../../../../components/_legacy/Input'
import { useBasicPopup } from '../../../../components/basic/popup/BasicPopup'
import CenterContainer from '../../../../components/common/CenterContainer'
import EmptyBlock from '../../../../components/common/EmptyBlock'
import Footer from '../../../../components/common/Footer'
import NewBasicContainer from '../../../../components/container/NewBasicContainer'
import TailwindWrapper from '../../../../components/container/TailwindWrapper'
import apis from '../../../../modules/apis'
import { axiosPost } from '../../../../modules/axiosHelper'
import { useCurrentUser } from '../../../../modules/context/UserContext'
import LinkLocale from '../../../../modules/i18n/LinkLocale'
import { s_password_reset } from '../../../../modules/i18n/strings/auto/wording'
import useTranslation from '../../../../modules/i18n/useTranslation'
import urls from '../../../../modules/urls'

const PasswordReset = () => {
  const { currentUser } = useCurrentUser()
  const basicPopup = useBasicPopup()
  const [warningMessage, setWarningMessage] = useState('')

  const emailRef = useRef(null)
  useEffect(() => {
    emailRef.current.focus()
  }, [])

  const { t, locale } = useTranslation()
  const handleSubmit = async (e) => {
    e.preventDefault()
    const email = emailRef.current.value
    const res = await axiosPost(apis.auth.password.resetToken.create(), {
      email,
    })
    if (res.error) {
      alert(
        'This may be an unregistered email account, or an email has already been sent. Please try again, or check your email.'
      )
    } else {
      basicPopup.show({
        id: 'success-modal',
        title: 'Password reset link sent.',
        maxW: 600,
        body: (
          <>
            <div>
              Please check your email {emailRef.current.value}. For security purposes, the link will expire in 10
              minutes.
            </div>
            <div className="mt-[40px] text-right">
              <Button primary md onClick={() => basicPopup.close('success-modal')}>
                OK
              </Button>
            </div>
          </>
        ),
      })
      emailRef.current.value = ''
    }
  }
  return (
    <NewBasicContainer landing>
      <TailwindWrapper>
        <CenterContainer>
          <div className="mx-auto w-full max-w-[405px] py-[32px] text-center">
            <div className="row justify-center">
              <div className="col-12 col-md-5 col-xl-4 my-5">
                {/*-- Heading --*/}
                <h1 className="text-h1 md:text-d3 mb-[16px] font-bold">{t(s_password_reset.reset_password)}</h1>

                {/*-- Subheading --*/}
                <p className="text-h4 mb-[32px] text-left text-gray-700">
                  {t(s_password_reset.enter_email_to_reset_your_password)}
                </p>

                {/*-- Form --*/}
                <form onSubmit={handleSubmit}>
                  <div className="mb-[24px]">
                    <Input
                      name="email"
                      type="email"
                      ref={emailRef}
                      clx="w-full"
                      placeholder={t(s_password_reset.enter_your_email)}
                      error={warningMessage ? true : false}
                      style={{ height: '52px' }}
                    />
                  </div>

                  {/*-- Submit --*/}
                  {/* {loading ?
                  <Button primary lg full >
                    <LoadingSpinner sm show />
                  </Button>
                  : */}
                  <Button primary lg full type="submit">
                    {t(s_password_reset.submit)}
                  </Button>
                  {/* } */}

                  {/*-- Link --*/}
                  <div className="text-sBody mt-[16px] text-left text-gray-500">
                    {t(s_password_reset.did_you_remember_your_password)} &nbsp;
                    <LinkLocale href={urls.student.auth.signIn}>
                      <span className="text-purple-500">{t(s_password_reset.sign_in)}</span>
                    </LinkLocale>
                  </div>
                </form>
              </div>
            </div>
          </div>
          <EmptyBlock h={200} />
        </CenterContainer>
        <Footer showMenu dark />
      </TailwindWrapper>
    </NewBasicContainer>
  )
}

export default PasswordReset
